export default __webpack_public_path__ + "static/item_03-71a745d341324c18d5c45b588e38dd52.jpg";